// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  authentication: {
    url: 'https://api.sanitas.es/oauth2p_hospitales/api/v1',
    applicationID: 'HOSP_SCANHC',
    credentials: 'Basic RWwzWjgwaGhyZm42VllwdEN3QWE1ZEt5djJjVkE4cHA6MHk3cjMzc1F2V1ZTanpKZA=='
  },
  backend: {
    url: 'https://api.sanitas.es'
  },
  opentok: {
    apikey: '45897492'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
